import React, { useState } from 'react';
import Header from '../../components/layout/Header';
import Footer from '../../components/layout/Footer';
import HeroSection from './components/HeroSection';
import ServiceCard from './components/ServiceCard';
import ServiceModal from './components/ServiceModal';
import InteractiveTools from './components/InteractiveTools';
import ComparisonMatrix from './components/ComparisonMatrix';
import TestimonialSection from './components/TestimonialSection';
import CTASection from './components/CTASection';

import axios from 'axios';

const ServicePortfolioHub = () => {
  const [selectedService, setSelectedService] = React.useState(null);
  const [services, setServices] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(null);

  const API_URL = import.meta.env.VITE_API_URL || 'http://localhost/isplw/api';

  const fetchServices = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_URL}/services.php`);
      if (response.data.status === 'success') {
        const mappedServices = response.data.data.map(s => ({
          ...s,
          id: parseInt(s.id),
          capabilities: s.capabilities ? s.capabilities.split(',') : [],
          process: [
            { title: "Analysis", description: "Assessment of your specific business needs" },
            { title: "Strategy", description: "Customized solution design and roadmap" },
            { title: "Execution", description: "Systematic implementation with expert support" },
            { title: "Optimization", description: "Continuous monitoring and performance tuning" }
          ]
        }));
        setServices(mappedServices);
      }
    } catch (err) {
      setError("Failed to load services. Please try again later.");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    fetchServices();
  }, []);
  const handleLearnMore = (service) => {
    setSelectedService(service);
  };

  const handleCloseModal = () => {
    setSelectedService(null);
  };

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Header />
      <main className="flex-grow pt-16">
        <HeroSection />

        <section className="py-12 md:py-16 lg:py-20 bg-background">
          <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
            <div className="text-center mb-8 md:mb-12">
              <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground mb-3 md:mb-4">
                Our Service Ecosystem
              </h2>
              <p className="text-sm md:text-base lg:text-lg text-muted-foreground max-w-3xl mx-auto">
                Comprehensive business solutions designed to drive growth, efficiency, and success across all aspects of your organization
              </p>
            </div>

            {loading ? (
              <div className="flex justify-center items-center py-20">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
              </div>
            ) : error ? (
              <div className="text-center py-20 text-destructive font-medium">
                {error}
              </div>
            ) : (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
                {services.map((service) => (
                  <ServiceCard
                    key={service.id}
                    service={service}
                    onLearnMore={handleLearnMore}
                  />
                ))}
              </div>
            )}
          </div>
        </section>

        <InteractiveTools />
        <ComparisonMatrix />
        <TestimonialSection />
        <CTASection />
      </main>
      <Footer />
      {selectedService && (
        <ServiceModal
          service={selectedService}
          onClose={handleCloseModal}
        />
      )}
    </div>
  );
};

export default ServicePortfolioHub;